// ─────────────────────────────────────────────────────────────────────────────
// StatsRow.js — the five KPI tiles. Owns the mapping from the hook's flat data
// to tile props, including WHICH delta formatter each tile needs: the five
// deltas are in three different units (percent, hours, points) and the suffix
// has to match the number under it.
// ─────────────────────────────────────────────────────────────────────────────
import { formatDelta } from "../../../services/dashboardService";
import { formatDeltaHours, formatDeltaPoints } from "../format";
import { UsersIcon, ClockIcon, ServerIcon, PulseIcon, ShieldIcon } from "./icons";
import StatCard from "./StatCard";
import styles from "./StatsRow.module.css";

export default function StatsRow({ loading, data }) {
  const {
    dau, dauDelta,
    sessionDur, sessionDurDelta,
    nodeUtil, nodeUtilDelta,
    routeSuccess, routeDelta,
    trustScore, trustDelta,
  } = data;

  // One entry per tile, in screen order. `delta` is already resolved to the
  // { trend, trendVal } pair the card renders.
  const tiles = [
    { label: "DAILY ACTIVE USERS",   value: dau,          icon: <UsersIcon />,  delta: formatDelta(dauDelta) },
    { label: "AVG SESSION DURATION", value: sessionDur,   icon: <ClockIcon />,  delta: formatDeltaHours(sessionDurDelta), unit: "h" },
    { label: "NODE UTILIZATION",     value: nodeUtil,     icon: <ServerIcon />, delta: formatDelta(nodeUtilDelta) },
    { label: "ROUTE SUCCESS",        value: routeSuccess, icon: <PulseIcon />,  delta: formatDeltaPoints(routeDelta, "%") },
    { label: "TRUST SCORE",          value: trustScore,   icon: <ShieldIcon />, delta: formatDeltaPoints(trustDelta) },
  ];

  return (
    <div className={styles.row}>
      {tiles.map(({ label, value, icon, delta, unit }) => (
        <StatCard
          key={label}
          label={label}
          value={value}
          unit={unit}
          icon={icon}
          {...delta}
          loading={loading || value === null}
        />
      ))}
    </div>
  );
}
